import PosthogService from '~/services/posthog/PosthogService';

export interface INewToYouInviteClickedPayload {
  professionalId: string;
}

/**
 * Fires when the user clicks "Invite" from the New to You tab
 * Event: dental_portal:new_to_you:invite_clicked
 */
export function fireNewToYouInviteClicked(payload: INewToYouInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:new_to_you:invite_clicked', {
    pro_category: 'New to You',
    professional_id: payload.professionalId,
  });
}
